<script>
	import { ethers } from 'ethers';
	import { onMount } from 'svelte';
	import myEpicGame from '../utils/MyEpicGame.json';
	import LoadingIndicator from './LoadingIndicator.svelte';
	export let characterNFT;
	import {
		CONTRACT_ADDRESS,
		transformCharacterData,
	} from '../components/stores';
	let characters = [];
	let gameContract = null;
	let mintingCharacter = false;

	onMount(async () => {
		const { ethereum } = window;
		if (ethereum) {
			const provider = new ethers.providers.Web3Provider(ethereum);
			const signer = provider.getSigner();
			const _gameContract = new ethers.Contract(
				$CONTRACT_ADDRESS,
				myEpicGame.abi,
				signer
			);

			/*
			 * This is the big difference. Set our gameContract in state.
			 */
			gameContract = _gameContract;
		} else {
			console.log('Ethereum object not found');
		}
	});

	$: if (gameContract) {
		getCharacters();
		gameContract.on('CharacterNFTMinted', onCharacterMint);

		// gameContract.on('CharacterNFTMinted', onCharacterMint);
	}

	const getCharacters = async () => {
		try {
			console.log('Getting contract characters to mint');

			/*
			 * Call contract to get all mint-able characters
			 */
			const charactersTxn = await gameContract.getAllDefaultCharacters();
			console.log('charactersTxn:', charactersTxn);

			/*
			 * Go through all of our characters and transform the data
			 */
			const _characters = charactersTxn.map((characterData) =>
				transformCharacterData(characterData)
			);

			/*
			 * Set all mint-able characters in state
			 */
			characters = _characters;
			// await onCharacterMint();
		} catch (error) {
			console.error('Something went wrong fetching characters:', error);
		}
	};
	const onCharacterMint = async (sender, tokenId, characterIndex) => {
		console.log(
			`CharacterNFTMinted - sender: ${sender} tokenId: ${tokenId.toNumber()} characterIndex: ${characterIndex.toNumber()}`
		);

		/*
		 * Once our character NFT is minted we can fetch the metadata from our contract
		 * and set it in state to move onto the Arena
		 */
		if (gameContract) {
			const _characterNFT = await gameContract.checkIfUserHasNFT();
			console.log('CharacterNFT: ', _characterNFT);

			characterNFT = transformCharacterData(_characterNFT);
		}
	};

	/*
	 * If our gameContract is ready, let's get characters!
	 */

	// onDestroy(() => {
	// 	if (gameContract) {
	// 		gameContract.off('CharacterNFTMinted', onCharacterMint);
	// 	}
	// });

	const mintCharacterNFTAction = async (characterId) => {
		try {
			if (gameContract) {
				mintingCharacter = true;
				console.log('Minting character in progress...');
				const mintTxn = await gameContract.mintCharacterNFT(characterId);
				await mintTxn.wait();
				console.log('mintTxn:', mintTxn);
				mintingCharacter = false;
			}
		} catch (error) {
			console.warn('MintCharacterAction Error:', error);
			mintingCharacter = false;
		}
	};
</script>

<div class="select-character-container">
	<h2>Mint Your Hero Wizard or Heroine Witch. Choose wisely.</h2>
	{#if characters.length > 0}
		<div class="character-grid">
			{#each characters as character, index}
				<div class="character-item" key={character.name}>
					<div class="name-container">
						<p>{character.name}</p>
					</div>
					<img src={character.imageURI} alt={character.name} />
					<button
						type="button"
						class="character-mint-button"
						on:click={() => mintCharacterNFTAction(index)}
						>{`Mint ${character.name}`}</button
					>
				</div>
			{/each}
		</div>
	{/if}
	{#if mintingCharacter}
		<div class="loading">
			<div class="indicator">
				<LoadingIndicator />
				<p>Minting In Progress...</p>
			</div>
			<img
				src="https://media2.giphy.com/media/61tYloUgq1eOk/giphy.gif?cid=ecf05e47dg95zbpabxhmhaksvoy8h526f96k4em0ndvx078s&rid=giphy.gif&ct=g"
				alt="Minting loading indicator"
			/>
		</div>
	{/if}
</div>

<style>
	.select-character-container {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: white;
	}

	.select-character-container .character-grid {
		width: 100%;
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
		grid-template-rows: repeat(auto-fit, minmax(300px, 1fr));
		grid-row-gap: 15px;
	}

	.character-grid .character-item {
		display: flex;
		flex-direction: row;
		position: relative;
		justify-self: center;
		align-self: center;
	}

	.character-item img {
		height: 300px;
		width: 350px;
		border-radius: 10px;
		object-fit: contain;
	}

	.character-item .name-container {
		position: absolute;
		background-color: #838383;
		border-radius: 5px;
		margin: 10px;
	}

	.character-item .name-container p {
		margin: 0;
		padding: 5px 10px 5px 10px;
		font-weight: bold;
	}

	.character-item .character-mint-button {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 40px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
		border: none;
		cursor: pointer;
		background-color: rgb(32, 129, 226);
		color: white;
		font-weight: bold;
		font-size: 16px;
	}

	.select-character-container .loading {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-top: 75px;
	}

	.select-character-container .loading .indicator {
		display: flex;
	}

	.select-character-container .loading .indicator p {
		font-weight: bold;
		font-size: 28px;
		padding-left: 5px;
	}

	.select-character-container .loading img {
		width: 450px;
		padding-top: 25px;
	}
</style>
